export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":""},{"name":"google-site-verification","content":"IxfFU87s4WTymNlknScr8jb6QhNai_ofsvf_Ex84zvM"}],"link":[{"rel":"preconnect","href":"https://cdn.contentful.com"},{"rel":"preconnect","href":"https://cdn.consentmanager.net"},{"rel":"preconnect","href":"https://a.delivery.consentmanager.net"},{"rel":"preconnect","href":"https://eu-data.kameleoon.io","crossorigin":""},{"rel":"dns-prefetch","href":"//apdi64wasm.kameleoon.io"}],"style":[],"script":[{"id":"kameleoon","defer":false,"async":true,"src":"//apdi64wasm.kameleoon.io/engine.js"},{"id":"kameleoon-init","defer":false,"async":false,"innerHTML":"window.kameleoonQueue = window.kameleoonQueue || [];"}],"noscript":[],"htmlAttrs":{"style":"scroll-behavior: smooth;"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true